import { accountsApi } from '../api';
import type { AuthenticatedUser, UserMetaDataResponse } from '../types';

export interface LocationData {
  country: string;
}

export const useUserLocation = ({ authenticatedUser }: { authenticatedUser: AuthenticatedUser | null }) => {
  const handleCheckIfUserHasRegisteredLocation = async (callback: (response: UserMetaDataResponse) => void) => {
    if (!authenticatedUser) {
      return;
    }

    await accountsApi.getUserMetaData(authenticatedUser?.username, callback);
  };

  const handleSaveLocation = async (
    data: LocationData,
    successCallback = () => {},
    errorCallback = () => {},
  ) => {
    await accountsApi.updateUserMetaData(authenticatedUser?.username || '', data, successCallback, errorCallback);
  };

  return {
    handleSaveLocation,
    handleCheckIfUserHasRegisteredLocation,
  };
};
